"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const setCanonicalLink = (req, res) => {
  res.setHeader('Link', `<${process.env.NEXT_PUBLIC_BASE_URL}${(req.url ?? '').split('?')[0]}>; rel="canonical"`);
};
var _default = exports.default = setCanonicalLink;